var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68332 16.149C1.56771 16.1488 1.4534 16.1246 1.34766 16.0778C1.24193 16.0311 1.14708 15.9628 1.06916 15.8774C0.989824 15.7927 0.929286 15.6922 0.891515 15.5825C0.853745 15.4728 0.839594 15.3563 0.849991 15.2407L1.05416 12.9957L10.4858 3.56738L13.4333 6.51405L4.00416 15.9415L1.75916 16.1457C1.73395 16.148 1.70864 16.1491 1.68332 16.149ZM14.0217 5.92488L11.075 2.97821L12.8425 1.21071C12.9199 1.13323 13.0118 1.07177 13.113 1.02983C13.2141 0.987894 13.3226 0.966309 13.4321 0.966309C13.5416 0.966309 13.65 0.987894 13.7512 1.02983C13.8524 1.07177 13.9443 1.13323 14.0217 1.21071L15.7892 2.97821C15.8666 3.05561 15.9281 3.14752 15.97 3.24868C16.012 3.34985 16.0336 3.45828 16.0336 3.5678C16.0336 3.67731 16.012 3.78575 15.97 3.88691C15.9281 3.98808 15.8666 4.07999 15.7892 4.15738L14.0225 5.92405L14.0217 5.92488Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.034fc34c191e8639d87e777b348d4c9f.svg";
export { ForwardRef as ReactComponent };